module.exports = function isString(x) {
  return typeof x === 'string';
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form-templates-bootstrap/~/tcomb/lib/isString.js
 ** module id = 71
 ** module chunks = 0
 **/